module.exports = __webpack_public_path__ + "assets/AnnulusDetailed.118e475dbb3aefb8795a28e64bd36978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AnnulusDetailed.png
// module id = 469
// module chunks = 0